import DesktopBanner from "../assets/images/ProductsBanner.png";
import MobileBanner from "../assets/images/Product-Page-banner.jpg";
import OurProductsSection from "./OurProductsSection";

const Products = () => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
      {/* Banner Section - Starts from absolute top */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <img
          src={DesktopBanner}
          alt="Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          className="desktop-banner"
        />

        <img
          src={MobileBanner}
          alt="Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          className="mobile-banner"
        />

        <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
      </div>
      <OurProductsSection />
    </div>
  );
};

export default Products;
